module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pending_wrap"
  }, [_c('step-status', {
    staticClass: "mt55",
    attrs: {
      "step": _vm.$route.meta.step
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Demo result")]), _vm._v(" "), (_vm.$route.query.status == "noshow") ? _c('div', {
    staticClass: "letter"
  }, [_c('p', [_vm._v("\n      It looks like your HAWO demo didn't take place. "), _c('br'), _vm._v("Kindly contact your recruiter via email at\n      "), _c('a', {
    attrs: {
      "href": ("mailto:" + _vm.recruiter_email)
    }
  }, [_vm._v(_vm._s(_vm.recruiter_email))]), _vm._v(" to further assist you.\n    ")]), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.$route.query.status == "failed") ? _c('div', {
    staticClass: "letter"
  }, [_c('p', [_vm._v("Dear " + _vm._s(_vm.full_name) + ",")]), _vm._v(" "), _c('p', [_vm._v("Thank you for your application. Unfortunately, we are unable to move forward in the recruitment process with your application.")]), _vm._v(" "), _c('p', [_vm._v("We appreciate the time and effort you have put into applying, and wish you the best of luck in your job search.")]), _vm._v(" "), _vm._m(1)]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n      Kind Regards, "), _c('br'), _vm._v(" HAWO Recruitment Team\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Kind Regards,"), _c('br'), _vm._v("HAWO Recruitment Team")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64ee553b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/demo/result.vue
// module id = 850
// module chunks = 1